import { Card } from "@cmsgov/ds-medicare-gov";
import React, { FunctionComponent } from "react";
import { useTranslate } from "../../../helpers";

interface ExtraHelpCardProps {
  lisText: string;
  year: string | number;
}

const ExtraHelpCard: FunctionComponent<ExtraHelpCardProps> = ({
  year,
  lisText,
}) => {
  const t = useTranslate();
  return (
    <Card className="mct-c-extra-help-card">
      <h3
        className="ds-text-heading--lg mct-c-extra-help-card__header ds-u-margin-bottom--1"
        data-testid={`${year}-extra-help-card`}
      >
        {`${year} ${t("summary_page.extra_help.card.header")}`}
      </h3>
      <p className="ds-u-measure--base ds-u-font-size--lg">{lisText}</p>
    </Card>
  );
};

export default ExtraHelpCard;
